import { Injectable, inject } from '@angular/core';
import { RemoteConfigParameter } from '@nx-customer-apps/shared/enums';
import { RemoteConfigService } from './remote-config.service';

@Injectable({
    providedIn: 'root'
})
export class CreateReportUtilsService {
    private remoteConfigService = inject(RemoteConfigService);

    public isDocumentationAvailable(): boolean {
        return !!this.remoteConfigService.config[RemoteConfigParameter.PdfConfiguratorDocumentationTabVisible];
    }
}
